import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// React Final Form
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';


// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentRemB from '@material-ui/icons/RemoveCircle';
import IconContentReset from '@material-ui/icons/DeleteSweep';

// Components Imports
import FieldCreator from './innerComponents/FieldCreator';
import CustomLoader from './innerComponents/CustomLoader';

// Assets imports
import '../styles/NewProject.css';

const buttonStyle = {
  marginRight: 12,
};

const cardStyles = {
  marginTop: 10,
  marginBottom: 20,
  boxShadow: "none",
  supervisors: {
    marginTop: 10,
    marginBottom: 20,
  }
};

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
};

const fieldStyle = {
  minHeight: "72px",
  width: "100%",
};

class UpdateUser extends Component {

  state = {
    description: '',
    url: '',
    dataSource: [],
    value: 4,
    roleValue: 1,
    active: true,
    refetched: false,
    activeWeeklyEmail: false,
  }



  _rolesItems() {
    return [{ id: "1", text: "Admin", enum: "ADMIN" }, { id: "2", text: "Office Manager", enum: "OFFICE" },
    { id: "3", text: "Supervisor", enum: "SUPERVISOR" }, { id: "4", text: "Operative", enum: "OPERATIVE" },
    { id: "5", text: "Contracts Manager", enum: "CONTRACTS" }, { id: "6", text: "Site Manager", enum: "SITE" }]
    .map((item, id) => (
      <MenuItem
        value={item.enum}
        key={item.enum}

      >{item.text}</MenuItem>
    ));
  }

  _regionsItems(items) {
    return items.map((item, id) => (
      <MenuItem
        value={item.id}
        key={item.id}
      >{item.name}</MenuItem>
    ));
  }

  _activeItems() {
    return (
      [<MenuItem value={true} key={true}>True</MenuItem>,
      <MenuItem value={false} key={false}>False</MenuItem>]
    )
  }

  _activeWeeklyEmail() {
    return (
      [<MenuItem value={true} key={true}>Yes, I would like to receive weekly region emails</MenuItem>,
      <MenuItem value={false} key={false}>No, I don't want to receive weekly region emails</MenuItem>]
    )
  }

  _roleToEnum(role) {
    switch (role) {
      case "Admin":
        return "ADMIN"
      case "Supervisor":
        return "SUPERVISOR"
      case "Operative":
        return "OPERATIVE"
      case "Office":
        return "OFFICE"
      case "Contracts Manager":
        return "CONTRACTS"
      case "Site Manager":
        return "SITE"
      default:
        return "OTHER"
    }


  }

  _createUser = async values => {
    // console.log(JSON.stringify(values, 0, 2))
    // name: $name, lastName: $lastName, role:  $role, email: $email, jobTitle: $jobTitle, regionId: $regionId, company: $company, active: $active, password: $password, passwordConfirmation: $passwordConfirmation


    const name = values.userName
    const lastName = values.UserLastName
    const role = values.role
    const email = values.userEmail
    const jobTitle = values.jobTitle
    const regionId = values.regionId
    const company = values.company
    const active = values.active
    const currentPassword = values.currentPassword
    const password = values.password
    const passwordConfirmation = values.passwordConfirmation
    const userId = this.props.match.params.id
    const getWeeklyEmail = values.getWeeklyEmail

    if(password && (passwordConfirmation === undefined)){
      alert("Password does not match Password Confirmation")
    }else{
      await this.props.updateMutation({
        variables: {
          name,
          lastName,
          email,
          role,
          jobTitle,
          regionId,
          company,
          active,
          currentPassword,
          password,
          passwordConfirmation,
          userId,
          getWeeklyEmail,
        }
      }).then(({ data }) => {
        alert("User '" + data.updateUser.fullName + "' has been updated successfully.", data)
        this.setState({refetched:false})
        this.props.history.push({
          pathname:"/users/list",
          state: { refetch: true}
        });
      }).catch((error) => {
        var error_text = "";
        error.graphQLErrors.map((item) => (error_text = error_text + "- " + item.message + "\n"))
        alert(error_text)
        console.log('there was an error sending the mutation', error);
      });
    }
  }

  componentDidMount(){
    this.props.data.refetch()
    .then(this.props.all_regions_query.refetch())
    .then(this.setState({
      refetched: true
    }))
  }

  render() {
    const TextFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        style={fieldStyle}
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const SelectedFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        style={fieldStyle}
        select
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    // Check if the query response is being loaded
    if (this.props.all_regions_query && this.props.all_regions_query.loading) {
      return <CustomLoader label={'Loading Regions'}/>
    }

    // Check if there were errrors
    if (this.props.all_regions_query && this.props.all_regions_query.error) {
      return <div> Regions Could not be loaded </div>
    }

    // Check if the query response is being loaded
    if (this.props.data && this.props.data.loading) {
      return <CustomLoader label={'Loading User'}/>
    }

    // Check if there were errrors
    if (this.props.data && this.props.data.error) {
      return <div> User Could not be loaded </div>
    }


    // Get the data to render it
    const all_regions = this.props.all_regions_query.regions;
    const user_to_be_update = this.props.data.private_user;

    // TODO this has to be moved to another place
    var adminsWhiteList = process.env.REACT_APP_CHANGE_PASSWORD_ADMIN_WHITELIST.split(',');
    const currentUserId = localStorage.getItem('current_user')
    let update_user_data_config_for_forms = {
      "Admin":
      adminsWhiteList.includes(currentUserId) ?
        [
          { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" } },
          { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" } },
          { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" } },
          { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue } },
          { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" } },
          { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" } },
          { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value } },
          { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active } },
          { input: { "component": TextFieldAdapter, "name": "password", "label": "Password", "type": "password" } },
          { input: { "component": TextFieldAdapter, "name": "passwordConfirmation", "label": "Password Confirmation", "type": "password" } },
          { fill_values: this._activeWeeklyEmail(), input: { "name": "getWeeklyEmail", "label": "Subscribe to Regions Weekly Email ?", "component": SelectedFieldAdapter, "value": this.state.activeWeeklyEmail, "disabled": localStorage.getItem("current_user_role") !== 'Admin'} }
        ] :
        [
          { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" } },
          { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" } },
          { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" } },
          { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue } },
          { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" } },
          { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" } },
          { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value } },
          { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active } },
          { fill_values: this._activeWeeklyEmail(), input: { "name": "getWeeklyEmail", "label": "Subscribe to Regions Weekly Email ?", "component": SelectedFieldAdapter, "value": this.state.activeWeeklyEmail, "disabled": localStorage.getItem("current_user_role") !== 'Admin'} }
        ],
      "Office Manager":
      [
        { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" } },
        { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" } },
        { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" } },
        { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue } },
        { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" } },
        { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" } },
        { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value } },
        { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active } },
      ],

      "Supervisor":
      [
        { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" , "disabled": true} },
        { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" , "disabled": true} },
        { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value , "disabled": true} },
        { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active , "disabled": true} },
        // { input: { "component": TextFieldAdapter, "name": "currentPassword", "label": "Current Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "password", "label": "Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "passwordConfirmation", "label": "Password Confirmation", "type": "password" } },
      ],

      "Operative":
      [
        { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" , "disabled": true} },
        { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" , "disabled": true} },
        { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value , "disabled": true} },
        { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active , "disabled": true} },
      ],
      "Contracts Manager":
      [
        { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" , "disabled": true} },
        { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" , "disabled": true} },
        { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value , "disabled": true} },
        { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active , "disabled": true} },
        // { input: { "component": TextFieldAdapter, "name": "currentPassword", "label": "Current Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "password", "label": "Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "passwordConfirmation", "label": "Password Confirmation", "type": "password" } },
      ],

      "Site Manager":
      [
        { input: { "component": TextFieldAdapter, "name": "userName", "label": "User Name" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "UserLastName", "label": "User Lastname" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "userEmail", "label": "Email" , "disabled": true} },
        { fill_values: this._rolesItems(), input: { "name": "role", "label": "User Role", "component": SelectedFieldAdapter, "value": this.state.roleValue , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "jobTitle", "label": "Job Title" , "disabled": true} },
        { input: { "component": TextFieldAdapter, "name": "company", "label": "Company" , "disabled": true} },
        { fill_values: this._regionsItems(all_regions), input: { "name": "regionId", "label": "Region", "component": SelectedFieldAdapter, "value": this.state.value , "disabled": true} },
        { fill_values: this._activeItems(), input: { "name": "active", "label": "Active", "component": SelectedFieldAdapter, "value": this.state.active , "disabled": true} },
        // { input: { "component": TextFieldAdapter, "name": "currentPassword", "label": "Current Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "password", "label": "Password", "type": "password" } },
        // { input: { "component": TextFieldAdapter, "name": "passwordConfirmation", "label": "Password Confirmation", "type": "password" } },
      ],
    }

    const updateUserFormFields = update_user_data_config_for_forms[localStorage.getItem("current_user_role")].map((field, id) =>
      <FieldCreator values={field.input} fill_values={field.fill_values} key={id} />
    );

    return (
      <Paper style={paperStyle} elevation={1} >
        <div>
          <Form
            onSubmit={this._createUser}
            mutators={{
              ...arrayMutators
            }}
            initialValues={{
              userName: user_to_be_update.name,
              UserLastName: user_to_be_update.lastName,
              userEmail: user_to_be_update.email,
              role: this._roleToEnum(user_to_be_update.role),
              jobTitle: user_to_be_update.jobTitle,
              company: user_to_be_update.company,
              regionId: user_to_be_update.region.id,
              active: user_to_be_update.active,
              getWeeklyEmail: user_to_be_update.getWeeklyEmail
            }}
            render={({ handleSubmit, mutators: { push, pop }, reset, submitting, pristine, values }) => (

              <form onSubmit={handleSubmit}>
                <div className="NewProject-header">
                  <div className="NewProject-title">
                    <span>Update User</span>
                  </div>
                  <div className="NewProject-actions">
                    <Button
                      color="primary"
                      onClick={this.props.history.goBack}
                    ><IconContentRemB style={{marginRight:8}}/> Cancel</Button>
                  </div>

                </div>
                <div className="NewProject-content">
                  <div style={cardStyles}>

                      Basic Information


                      <div>
                        {updateUserFormFields}
                      </div>

                  </div>

                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </div>
                <div className="NewProject-detailFooter">
                  <div className="buttons">
                    <Button variant="contained"
                      type="submit"
                      color="primary"
                      style={buttonStyle}
                      disabled={submitting || pristine}
                    ><IconContentSend style={{marginRight:8}}/> Submit</Button>
                    <Button variant="contained"
                    type="button"
                      color="secondary"
                      style={buttonStyle}
                      onClick={reset}
                      disabled={submitting || pristine}
                    ><IconContentReset style={{marginRight:8}}/> Reset</Button>
                  </div>
                </div>
              </form>

            )}
          />
        </div>
      </Paper>

    );
  }
}
const updateUser = gql`
  mutation updateUser($userId: ID!, $name: String, $lastName: String, $role: String, $email: String, $jobTitle: String, $regionId: ID, $company: String, $currentPassword: String, $password: String, $passwordConfirmation: String, $active: Boolean, $getWeeklyEmail: Boolean) {
    updateUser(userId: $userId, input : {name: $name, lastName: $lastName, email: $email, role: $role, jobTitle: $jobTitle, regionId: $regionId, company: $company, currentPassword: $currentPassword, password: $password, passwordConfirmation: $passwordConfirmation, active: $active, getWeeklyEmail: $getWeeklyEmail} ) {
      id
      name
      fullName
    }
  }
`;


const PROJECTS_QUERY = gql`
  query user_query($selectedId: ID!) {
    private_user(id: $selectedId) {
      name
      lastName
      email
      role
      jobTitle
      company
      region{
        id
      }
      active
      getWeeklyEmail
    }
  }
`;



const ALL_REGIONS_QUERY = gql`
  query {
    regions {
      id
      name
    }

  }
`;


export default compose(
  graphql(PROJECTS_QUERY, {
    options: (props) => ({ variables: { selectedId: props.match.params.id } })
  }),
  graphql(updateUser, { name: 'updateMutation', options: {
    refetchQueries: ["all_users_query"]
  } }),
  graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' })
)(UpdateUser);


// WEBPACK FOOTER //
// src/components/UpdateUser.js